export const UNASSIGNED_COLUMN_ID = '__unassigned__';

/** Company meetings from `meetings` collection (see useTeamLabelCalendarData). */
export const MEETINGS_COLUMN_ID = '__meetings__';

export function appointmentBelongsToColumn(appointment, columnId) {
  const eid =
    appointment.employeeId ||
    appointment.staffId ||
    appointment.employee?.id ||
    null;
  if (columnId === UNASSIGNED_COLUMN_ID) return !eid;
  return eid === columnId;
}

export function calendarItemBelongsToColumn(item, columnId) {
  if (item?.type === 'meeting') {
    return columnId === MEETINGS_COLUMN_ID;
  }
  return appointmentBelongsToColumn(item, columnId);
}
